import { LitElement, html, css, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized, msg, str } from "@lit/localize";
import type { startseite } from "@progressive-development/politik-model";

import { zeitpunktGenau } from "../../../../../common/format/de-format.js";
import { ROUTE_QUELLEN } from "../../../../../config/navigation.js";
import { navigateOnClick } from "../../../../../common/router/app-navigation.js";
import { blockStyles } from "../../../../../common/styles/block-styles.js";
import { juengsterLauf } from "../../../../rahmen/sections/app-datenstand-tabelle.js";

/**
 * Abschluss — der Stand der Daten, die KURZFORM der Quellen-Seite
 * (FACHKONZEPT-rahmen.md, 4.4): der jüngste Lauf als ein Satz und der Weg zu
 * allen Quellen und Regeln. Kein Titel, keine Attribution, kein Eintrag in der
 * Abschnittsleiste: Die Attribution steht im Fuß jeder Seite, und eine Quelle
 * hervorzuheben machte sie prominenter als die anderen. Tabelle und Regeln
 * leben auf /quellen — dasselbe Muster wie Organigramm (kompakt → /gremien).
 */
@customElement("app-quellen-block")
@localized()
export class AppQuellenBlock extends LitElement {
  /** Ein Lauf je Quelle — der jüngste abgeschlossene. */
  @property({ attribute: false }) datenstand: startseite.DatenstandEintrag[] = [];

  static override styles = [
    blockStyles,
    css`
      /* Kolophon: Kennung als Etikett, Satz in Textschrift, Weg darunter. */
      .kennung {
        margin: 0;
        font-family: var(--portal-font-mono);
        font-size: var(--portal-size-meta);
        color: var(--portal-ink-2);
        text-transform: uppercase;
        letter-spacing: var(--portal-tracking-caps);
      }
      .stand {
        margin: var(--portal-space-1) 0 0;
        max-width: 60ch;
      }
      .weiter {
        margin-top: var(--portal-space-3);
        color: inherit;
      }
    `,
  ];

  override render() {
    const pfad = `/${ROUTE_QUELLEN}`;
    const juengster = juengsterLauf(this.datenstand);
    return html`
      <p class="kennung">${msg("Datenstand", { id: "app.start.quellen.kennung" })}</p>
      ${
        juengster
          ? html`<p class="stand">
              ${msg(
                str`Alle Daten aus ${this.datenstand.length} Quellen, zuletzt gelesen am ${zeitpunktGenau(juengster)}.`,
                { id: "app.start.quellen.kurz" },
              )}
            </p>`
          : nothing
      }
      <a class="weiter" href=${pfad} @click=${(e: Event) => navigateOnClick(e, pfad)}
        >${msg("Alle Quellen und Regeln →", { id: "app.start.quellen.weiter" })}</a
      >
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "app-quellen-block": AppQuellenBlock;
  }
}
